import generatePagination from "./paginationGenerator";
import paginationStyles from "./Pagination.module.css";
import PageItem from "./PageItem";
import React from "react";
import { CustomPage } from "./PageList";
import { Pagination } from "Pagination";
import { UpdateSearchParams } from "List";

type PageListProps = {
  updateSearchParams: UpdateSearchParams;
  pagination: Pagination;
};

function findPage(pages: Pagination[], pageToFind: number) {
  return pages.find((page) => page.current === pageToFind);
}

export default function PageListWithoutTotalCount(props: PageListProps) {
  const { updateSearchParams, pagination } = props;
  const pages = generatePagination(pagination);
  const prevPage = findPage(pages, pagination.current - 1);
  const nextPage = findPage(pages, pagination.current + 1);
  return (
    <div className={paginationStyles.root}>
      <CustomPage
        updateSearchParams={updateSearchParams}
        type="prev"
        page={prevPage}
      />
      {pages.map((page) => {
        if (!page.block) {
          return (
            <span key={page.current} className={paginationStyles.ellipsis}>
              ...
            </span>
          );
        }
        if (page.current === pagination.current) {
          return (
            <PageItem
              className={paginationStyles[page.block]}
              currentPage={pagination.current}
              key={page.current}
              updateSearchParams={updateSearchParams}
              pagination={page}
              type="page"
            />
          );
        }
        return null;
      })}
      <CustomPage
        updateSearchParams={updateSearchParams}
        type="next"
        page={nextPage}
      />
    </div>
  );
}
